import { GuidePage } from './GuidePage';

export default GuidePage;
